module.exports = __webpack_public_path__ + "static/media/About.822ced07.png";